import { render } from "./SendOtp.vue?vue&type=template&id=33125aef&scoped=true"
import script from "./SendOtp.vue?vue&type=script&lang=js"
export * from "./SendOtp.vue?vue&type=script&lang=js"

import "./SendOtp.vue?vue&type=style&index=0&id=33125aef&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33125aef"]])

export default __exports__